exports.f = Object.getOwnPropertySymbols;


/*****************
 ** WEBPACK FOOTER
 ** ./~/_core-js@2.4.1@core-js/library/modules/_object-gops.js
 ** module id = 102
 ** module chunks = 0 1
 **/